<div class="edit-user-dialog">
  <h2 mat-dialog-title>#{{ data.editedUser.id }} - {{ data.editedUser.name }}</h2>

  <mat-dialog-content [formGroup]="form">
    <mat-form-field>
      <mat-label>Managing Company Authorities</mat-label>
      <mat-select
        formControlName="managingCompanyAuthorities"
        multiple
        [compareWith]="compareAuthority"
      >
        <mat-select-trigger>
          @if (authorityOptions.length > 0) {
            {{ getManagingCompanyAuthoritiesLabel() }}
          }
        </mat-select-trigger>

        @for (authority of authorityOptions; track authority) {
          <mat-option [value]="authority">
            {{ authority }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button type="button" (click)="close()">Close</button>
    <button mat-raised-button color="primary" type="button" (click)="save()">Save</button>
  </mat-dialog-actions>
</div>